import {DisplaySession} from 'helpers/enums/display-session';

/**
 * File Overview
 * Normalization helper object for the sessions API
 */
export default {
  normalize(data) {
    let newData = data;

    newData = this.removeUnkownSessions(newData);

    newData['sessionObjects'] = newData.map(obj => {
      return Object.assign({},
        obj,
        DisplaySession[obj.session_type]
      );
    });

    return newData;
  },

  removeUnkownSessions(data) {
    return data.filter(obj => {
      return obj.session_type !== 'unknown' && obj.session_type !== null;
    });
  }
}



// WEBPACK FOOTER //
// ./src/client/normalizers/sessions-normalizer.js